import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataserviceService } from '../dataservice.service';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';

interface DocSpecEntry {
  field: string;
  value: unknown;
  index: number;
}

interface DocSpecFieldConfig {
  label: string;
  aliases: string[];
}

type DocSpecFallbackMap = Record<string, unknown>;

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css'
})
export class UserProfileComponent {

  queryParams: any;
  currentUser: any;
  pdfUrl: any;
  docValues: any;

  roles: any[] = [];
  companies: any[] = [];
  providers: any[] = [];
  groups: any[] = [];
  fidiumExternals: any = [];
  availableDocuments: any = [];
  repDocs: any = [];
  companyDocs: any = [];

  docSpecs: DocSpecEntry[] = [];
  docSpecCombined: string = '';

  userForm: FormGroup;

  private docSpecFallbackData: DocSpecFallbackMap = {};

  loading: boolean = false;
  docModal: boolean = false;
  docSpecModal: boolean = false;

  badgeImg: any;
  badgePath: string | null = null;
  badgeDenyModal: boolean = false;
  badgeDenyReason: string = '';
  badgeNotify: boolean = false;

  docUrl: any;
  docBlob: Blob | null = null;
  private docObjectUrl: string | null = null;

  backgroundForm: FormGroup;
  backgroundModal: boolean = false;
  usersBackgrounds: any;
  bgLoader: boolean = false;

  denyModal: boolean = false;
  deniedDoc: any;
  denyReason: any;
  checked: boolean = false;

  userQuizzes: any[] = [];
  allQuizzes: any[] = [];
  assignQuizModal: boolean = false;
  assignQuizForm: FormGroup = new FormGroup({
    quiz_id: new FormControl(null, Validators.required)
  });
  targetUserId: string | null = null;

  distributors: any[] = [];
  companyUsersForHierarchy: any[] = [];
  payHierarchyForm: FormGroup = new FormGroup({
    provider_id: new FormControl(null, Validators.required),
    company_id: new FormControl(null),
    // distributor_id: new FormControl(null),
    associated_users: new FormControl([])
  });
  editHierarchyForm: FormGroup = new FormGroup({
    provider_id: new FormControl(null, Validators.required),
    company_id: new FormControl(null),
    associated_users: new FormControl([])
  });
  payHierarchyList: any[] = [];
  payHierarchyLoading: boolean = false;
  payHierarchyUsers: any[] = [];
  payHierarchyEligibleUsers: any[] = [];
  editingHierarchyId: string | null = null;
  editHierarchyModal: boolean = false;
  viewHierarchyModal: boolean = false;
  viewHierarchyUsers: any[] = [];
  viewHierarchyOwner: string = '';
  importHierarchyModal: boolean = false;
  importFileName: string = '';
  canSeePayHierarchy: boolean = false;

  isViewingOwnProfile: boolean = false;
  requestProviderModal: boolean = false;
  availableProviders: any[] = [];
  requestProviderForm: FormGroup = new FormGroup({
    provider_ids: new FormControl([], Validators.required)
  });

  planProviderModal: boolean = false;
  planProviderForm: FormGroup;
  availableProviderPlans: any = [];
  userPlans: any = [];
  userPlanLoading: boolean = false;

  portals: any;
  validateForm!: FormGroup;
  portalLoading: boolean = false;
  docLoading: boolean = false;
  quizLoading: boolean = false;

  documentModal: boolean = false;
  documentForm: FormGroup;
  portalsCompanies = [];
  documentLoading: boolean = false;
  userLogs: any = [];
  noteForm: FormGroup

  isSuperAdmin: boolean = false;
  usersForSA: any[] = [];

  private readonly docSpecFieldConfig: DocSpecFieldConfig[] = [
    { label: 'First Name', aliases: ['First Name'] },
    { label: 'Last Name', aliases: ['Last Name'] },
    { label: 'Phone Number', aliases: ['Phone Number', 'Phone'] },
    { label: 'Email', aliases: ['Email', 'Email Address'] },
    {
      label: 'Street Address',
      aliases: ['Street Address', 'Street Address (W9)', 'Bank Account Street Address']
    },
    { label: 'City', aliases: ['City', 'City (W9)'] },
    { label: 'State', aliases: ['State', 'State (W9)', 'ST'] },
    { label: 'Zip Code', aliases: ['Zip Code', 'Zip', 'ZipCode'] },
    { label: 'Personal or Business Account', aliases: ['Personal or Business Account', 'Account Type'] },
    { label: 'Social', aliases: ['Social', 'SocialSecurity#', 'SSN', 'SS#'] },
    {
      label: 'What is the Name of your LLC?',
      aliases: ['What is the Name of your LLC?', 'Name of LLC', 'Business Name (W9)']
    },
    {
      label: 'Provide the EIN (9 digits) of your LLC',
      aliases: ['Provide the EIN (9 digits) of your LLC', 'EIN#', 'EIN Number']
    },
    { label: 'Bank Name', aliases: ['Bank Name', 'Name of Bank'] },
    { label: 'Routing Number', aliases: ['Routing Number'] }
  ];

  private parseRepName(value: unknown): { first: string; last: string } | null {
    if (typeof value !== 'string') {
      return null;
    }

    const parts = value
      .split(/\s+/)
      .map(part => part.trim())
      .filter(part => part.length > 0);

    if (!parts.length) {
      return null;
    }

    const first = parts[0];
    const last = parts.length > 1 ? parts[parts.length - 1] : '';

    return { first, last };
  }

  constructor(
    private route: ActivatedRoute,
    private data: DataserviceService,
    public router: Router,
    private modal: NzModalService,
    private app: AppComponent,
    private sanitizer: DomSanitizer,
    private location: Location,
    private message: NzMessageService,
    private fb: FormBuilder) {

      this.noteForm = new FormGroup({
        'note': new FormControl(null, [Validators.required])
      })

    this.userForm = new FormGroup({
      'id': new FormControl(null),
      'user_id': new FormControl(null),
      'first_name': new FormControl(null, [Validators.required]),
      'last_name': new FormControl(null, [Validators.required]),
      'email': new FormControl(null),
      'phone': new FormControl(null, [Validators.required]),
      'date_of_birth': new FormControl(null)
    });

    this.backgroundForm = new FormGroup({
      'id': new FormControl(null),
      'backgroundId': new FormControl(null),
      'status': new FormControl(null),
      'failedDate': new FormControl(null),
      'completedDate': new FormControl(null),
      'providerId': new FormControl(null),
      'companyId': new FormControl(null),
      'distributorId': new FormControl(null)
    })

    this.planProviderForm = new FormGroup({
      'plan_id': new FormControl(null)
    })

    this.documentForm = new FormGroup({
      'document_id': new FormControl(null, [Validators.required]),
      'company_id': new FormControl(null)
    })

  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });

    this.validateForm = this.fb.group({
      portalForms: this.fb.array([]) 
    });

    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    console.log(this.currentUser);

    if (this.currentUser?.super_admin) {
      this.loadDistributors();
    }

    if (this.hasPermission('view_all_users')) {
      this.getCompanies();
    } else {
      this.getDistributorCompanies();
    }
    this.getUserData();
    this.isUserSuperAdmin();
  }

  get portalArray(): FormArray {
    return this.validateForm.get('portalForms') as FormArray;
  }

  hasPermission(permission: string): boolean {
    return this.app.hasPermission(permission);
  }

  isUserSuperAdmin() {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.isSuperAdmin = this.currentUser?.super_admin;
    if (this.isSuperAdmin) {
      this.getUsersForSA();
    }
  }

  getUsersForSA(){
    this.data.getData(`users/users-list`).subscribe({
      next: (res: any) => {
        // console.log('res', res);
        this.usersForSA = res;
      }
    })
  }

  async getUserData() {
    this.loading = true;

    this.data.getData(`users/user-profile/${this.queryParams.user}`)
      .subscribe({
        next: async (res: any) => {
          // console.log(res)
          if (res) {

            if (res.headshotUrl) {
              let badgeImg = await this.data.getSupabaseBadge(res.headshotUrl);
              this.badgeImg = URL.createObjectURL(badgeImg)
              this.badgePath = res.headshotUrl;
            } else {
              this.badgeImg = null;
              this.badgePath = null;
            }

            this.userForm.patchValue({
              id: res.id,
              user_id: res.user_id,
              first_name: res.first_name,
              last_name: res.last_name,
              email: res.email,
              phone: res.phone,
              date_of_birth: this.normalizeDateForInput(res.date_of_birth),
            });

            this.userForm.get('user_id')?.disable();
            this.targetUserId = res.id || res.user_id || null;
            this.isViewingOwnProfile = this.currentUser?.id === res.id;
            if (this.targetUserId) {
              this.loadPayHierarchies();
            }

            this.loading = false;

          }

          this.updateDocSpecFallbacks(res);

          this.portalInfo()

        }
      })
  }

  async getPortalDocs() {
    this.docLoading = true;
    this.data.getData(`portals/portal-docs/${this.userForm.get('id')?.value}`)
      .subscribe({
        next: (res: any) => {
          console.log(res)
          this.repDocs = res;
          this.docLoading = false;
        },
        error: (err: any) => {
          console.log(err)
          this.docLoading = false;
        }
      })
  }

  async portalInfo() {
    this.portalLoading = true;
    this.data.getData(`portals/portal-info/${this.userForm.get('id')?.value}`)
      .subscribe({
        next: (res: any) => {
          this.portals = res;
          // console.log('this.portals', this.portals);

          this.portalsCompanies = res.map((portal: any) => {
            return {
              id: portal.company_id,
              name: portal.company_name
            }
          });

          const formArray = this.validateForm.get('portalForms') as FormArray;
          formArray.clear();

          res.forEach((portal: any) => {
            const selectedProviderIds = portal.providers ? portal.providers.map((p: any) => p.id) : []; 
            
            const externalGroups = Object.entries(portal.provider_externals || {}).map(([key, value]) => {
              return this.fb.group({
                key: [key],
                value: [value]
              });
            });

            formArray.push(
              this.fb.group({
                id: [portal.id],
                company_name: [portal.company_name],
                status: [portal.status],
                providers: [selectedProviderIds || []] ,
                roleId: [portal.roleId],
                fidiumInput: [null], 
                fidiumExternals: [portal.external_ids || []],
                providerExternals: this.fb.array(externalGroups),
                groupsVisibility: [portal.viewable_groups || []],
                pins: [portal.makePins || false],
                areas: [portal.makeAreas || false],
                recruiter: [{ value: portal.recruiter?.trim() || 'N/A', disabled: !this.isSuperAdmin }],
                recruiter_id: [portal.recruiter_id],
                company_id: [portal?.company_id],
                user_id: [portal?.user_id],
                distributor_id: [portal?.distributor_id]
              })
            );

          });

          this.providers = [...new Set(
            res.flatMap((portal: any) => portal?.options?.providers ?? [])
          )];

          // console.log('this.portalArray', this.portalArray.value);
          this.portalLoading = false;
        },
        error: (err: any) => {
          console.log(err)
          this.portalLoading = false;
        }
      })

  }

  onCompanyChange(event: any) {
    const company = this.companies.find((c: any) => {
      if(c.id == event) {
        return c
      }})
    this.backgroundForm.get('distributorId')?.setValue(company?.distributor_id)
  }

  async savePortal(i: any) {
    this.loading = true;

    let obj = this.portalArray.at(i);
    // console.log('obj', obj.value);
    this.data.postData(obj.value, 'portals/update-portal')
      .subscribe({
        next: (res: any) => {
          if (res?.result === 'success') {
            this.message.success('Portal updated successfully');
            this.loading = false;
          } else {
            this.loading = false;
            this.message.error('Failed to update portal');
          }
        },
        error: (err: any) => {
          this.loading = false;
          this.message.error('Failed to update portal');
        }
      })

  }

  async activate(i: any) {
    this.portalLoading = true;

    let obj = this.portalArray.at(i);

    this.data.postData(obj.value, 'portals/activate-portal')
      .subscribe({
        next: (res: any) => {
          if (res?.result === 'success') {
            this.message.success('Portal activated successfully');
            this.portalInfo();
          } else {
            this.loading = false;
            this.message.error('Failed to activate portal');
          }
        },
        error: (err: any) => {
          this.loading = false;
          this.message.error('Failed to activate portal');
        }
      })

  }

  async deactivate(i: any) {
    this.portalLoading = true;

    let obj = this.portalArray.at(i);

    this.data.postData(obj.value, 'portals/deactivate-portal')
      .subscribe({
        next: (res: any) => {
          if (res?.result === 'success') {
            this.message.success('Portal deactivated successfully');
            this.portalInfo()
          } else {
            this.loading = false;
            this.message.error('Failed to deactivate portal');
          }
        },
        error: (err: any) => {
          this.loading = false;
          this.message.error('Failed to deactivate portal');
        }
      })

  }

  openBadgeDeny() {
    if (!this.badgePath) {
      this.message.error('No badge image to deny');
      return;
    }
    this.badgeDenyModal = true;
  }

  handleBadgeDenyCancel() {
    this.badgeDenyModal = false;
    this.badgeDenyReason = '';
    this.badgeNotify = false;
    this.loading = false;
  }

  denyBadgeImage() {
    if (!this.badgePath) {
      this.message.error('No badge image to deny');
      return;
    }

    this.loading = true;

    const payload = {
      user: this.userForm.get('id')?.value,
      headshotUrl: this.badgePath,
      deniedReason: this.badgeDenyReason,
      notify: this.badgeNotify,
      phone: this.userForm.get('phone')?.value,
      rep: `${this.userForm.get('first_name')?.value || ''} ${this.userForm.get('last_name')?.value || ''}`.trim()
    };

    this.data.postData(payload, 'users/deny-badge').subscribe({
      next: (res: any) => {
        if (res?.result === 'success') {
          this.message.success('Badge denied');
          this.badgeImg = null;
          this.badgePath = null;
          this.handleBadgeDenyCancel();
          this.getUserData();
        } else {
          this.message.error('Failed to deny badge');
          this.loading = false;
        }
      },
      error: () => {
        this.message.error('Failed to deny badge');
        this.loading = false;
      }
    });
  }

  async getCompanyDocs() {
    this.data.getData(`templates/company-docs/${this.userForm.get('company_id')?.value}`)
      .subscribe({
        next: (res: any) => {
          this.companyDocs = res.docs;
          this.loading = false;
        }
      })
  }

  getUserQuizzes() {
    if (!this.userForm.get('id')?.value) return;
    this.quizLoading = true;
    this.data.getData('quizzes/user-quizzes', { params: { user_id: this.userForm.get('id')?.value } })
      .subscribe((res: any) => {
        this.userQuizzes = res?.data || [];
        this.quizLoading = false;
      });
  }

  openAssignQuizModal() {
    if (!this.allQuizzes.length) {
      this.data.getData('quizzes').subscribe((res: any) => {
        this.allQuizzes = (Array.isArray(res?.data) ? res.data : []).filter((q: any) => q?.status === 'active');
      });
    }
    this.assignQuizForm.reset({ quiz_id: null });
    this.assignQuizModal = true;
  }

  assignQuizToUser() {
    if (this.assignQuizForm.invalid) return;
    const quiz_id = this.assignQuizForm.value.quiz_id;
    const company_id = this.currentUser?.company_id;
    this.data.postData({ user_id: this.targetUserId, quiz_id, company_id }, 'quizzes/assign-to-user').subscribe({
      next: (res: any) => {
        if (res?.result === 'success') {
          this.message.success('Quiz assigned');
          this.assignQuizModal = false;
          if (this.targetUserId) {
            this.getUserQuizzes();
          }
        } else {
          this.message.error(res?.message || 'Failed to assign quiz');
        }
      },
      error: (err: any) => {
        this.message.error(err?.error?.message || 'Failed to assign quiz');
      }
    });
  }

  getCompanies() {
    this.data.getData('company')
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data;
        },
        error: (err: any) => {
          console.log('error on get all companies: ', err)
        }
      })
  }

  getDistributorCompanies() {
    this.data.getData(`company/companies-by-distributor/${this.currentUser?.distributor_id}`)
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data;
        },
        error: (err: any) => {
          console.log('error on get companies by distributor: ', err)
        }
      });
  }

  saveUserInfo() {

    if (this.userForm.valid) {
      this.loading = true;

      this.data.postData(this.userForm.value, 'users/update-user-info')
        .subscribe({
          next: (res: any) => {
            if (res?.result == 'success') {
              this.getUserData()
              this.loading = false;
            }else {
              this.loading = false;
              alert(res?.message)
            }
          }
        })
    }
  }

  updateStatus() {
    let status = this.userForm.get('status')?.value == 'active' ? 'inactive' : 'active';

    this.modal.confirm({
      nzTitle: `Update user status`,
      nzContent: `Are you sure you want to mark this user as ${status}?`,
      nzOnOk: () => {
        this.loading = true;
        this.data.postData({ status: status, id: this.userForm.get('id')?.value }, `users/update-status`)
          .subscribe({
            next: (res: any) => {
              if (res?.result == 'success') {
                this.loading = false
                this.userForm.get('status')?.setValue(status);
              }
            }
          })
      },
    });
  }

  getFidiumChips(index: number): string[] {
    return this.portalArray.at(index).get('fidiumExternals')?.value || [];
  }

  addChip(index: number) {
    const group = this.portalArray.at(index);
    const inputControl = group.get('fidiumInput');
    const listControl = group.get('fidiumExternals');

    const value = inputControl?.value?.trim();
    const currentList = listControl?.value || [];

    if (value && !currentList.includes(value)) {
      listControl?.setValue([...currentList, value]);
      inputControl?.setValue(null);
    }
  }

  removeChip(index: number, chipToRemove: string) {
    const listControl = this.portalArray.at(index).get('fidiumExternals');
    const currentList = listControl?.value || [];
    
    listControl?.setValue(currentList.filter((c: string) => c !== chipToRemove));
  }

  getNestedExternals(portalIndex: number): FormArray {
    return this.portalArray.at(portalIndex).get('providerExternals') as FormArray;
  }

  addProviderExternal(portalIndex: number) {
    const arr = this.getNestedExternals(portalIndex);
    arr.push(this.fb.group({
      key: [null],
      value: [null]
    }));
  }

  removeProviderExternal(portalIndex: number, externalIndex: number) {
    this.getNestedExternals(portalIndex).removeAt(externalIndex);
  }

  get providerExternals(): FormArray {
    return this.userForm.get('providerExternals') as FormArray;
  }

  goBack() {
    this.location.back();
  }

  openDoc(d: any) {
    const id = this.message.loading('Retrieving document, this could take a while..', { nzDuration: 0 }).messageId;

    this.data.getFile(`templates/view-doc/${d.file_path}`)
      .subscribe({
        next: (blob: Blob) => {
          setTimeout(() => {
            this.message.remove(id)
          }, 1000);

          if (this.docObjectUrl) {
            URL.revokeObjectURL(this.docObjectUrl);
            this.docObjectUrl = null;
          }

          const pdfBlob = blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' });
          this.docBlob = pdfBlob;

          const objectUrl = URL.createObjectURL(pdfBlob);
          this.docObjectUrl = objectUrl;
          this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

          this.docModal = true;

        },
        error: (err: any) => {
          this.message.remove(id);
          console.error('Failed to retrieve document', err);
          this.message.error('Failed to retrieve document');
        }
      })

  }

  viewDoc(d: any) {
    const id = this.message.loading('Getting doc specs...', { nzDuration: 0 }).messageId;

    this.data.getData(`templates/view-doc-spec/${d.file_path}`)
      .subscribe((res: any) => {
        setTimeout(() => {
          this.message.remove(id)
        }, 1000);


        this.docSpecs = res?.submitters?.[0]?.values

        // console.log(res)
        this.docSpecCombined = this.docSpecs
          .map(spec => this.getDocSpecDisplayValue(spec).trim())
          .join(', ');
        this.docSpecModal = true;
      })
  }

  saveDenyDoc() {
    this.loading = true;

    const obj = {
      doc: this.deniedDoc.id,
      file_path: this.deniedDoc.file_path,
      deniedReason: this.denyReason,
      textRep: this.checked,
      user: this.userForm.get('id')?.value,
      phone: this.userForm.get('phone')?.value,
      rep: this.userForm.get('first_name')?.value + ' ' + this.userForm.get('last_name')?.value,
      docName: this.deniedDoc.name,
      company_id: this.deniedDoc.company_id,
      distributor_id: this.deniedDoc.distributor_id
    }

    this.data.postData(obj, 'templates/doc-denied')
      .subscribe({
        next: (res: any) => {
          if (res?.result === 'success') {
            this.message.success('Document denied successfully');
            this.getUserData();
            this.handleDenyCancel();
          } else {
            this.message.error('Failed to deny document');
          }
        },
        error: (err: any) => {
          this.message.error('Failed to deny document');
          this.loading = false;
        }
      })
  }

  denyDoc(d: any) {
    // console.log(d)
    this.denyModal = true;
    this.deniedDoc = d;
  }

  handleDenyCancel() {
    this.deniedDoc = null;
    this.denyReason = null;
    this.denyModal = false;
    this.checked = false;
    this.loading = false;
  }

  closeDoc() {
    this.docModal = false;
    this.docUrl = null
    if (this.docObjectUrl) {
      URL.revokeObjectURL(this.docObjectUrl);
      this.docObjectUrl = null;
    }
    this.docBlob = null;
  }

  closeDocSpec() {
    this.docSpecModal = false;
    this.docSpecs = [];
    this.docSpecCombined = '';
  }

  normalizeDocSpecs(values: any): DocSpecEntry[] {
    if (!Array.isArray(values)) {
      return [];
    }

    const normalizeKey = (value: string) => value.trim().toLowerCase();
    const entries = values
      .filter((item: any) => item && item.field)
      .map((item: any, index: number) => ({
        field: String(item.field).trim(),
        value: item.value,
        index
      }));

    const lookup = new Map<string, { value: unknown; index: number }>();
    for (const entry of entries) {
      const key = normalizeKey(entry.field);
      if (!lookup.has(key)) {
        lookup.set(key, { value: entry.value, index: entry.index });
      }
    }

    const hasMeaningfulValue = (val: unknown) => {
      if (val === null || val === undefined) {
        return false;
      }
      if (typeof val === 'string') {
        return val.trim().length > 0;
      }
      return true;
    };

    const findMatch = (aliases: string[]) => {
      for (const alias of aliases) {
        const match = lookup.get(normalizeKey(alias));
        if (match) {
          return match;
        }
      }
      return undefined;
    };

    const repNameEntry = findMatch(['Rep Name']);
    const parsedRepName = this.parseRepName(repNameEntry?.value);
    const businessNameEntry = findMatch([
      'Business Name (W9)',
      'What is the Name of your LLC?',
      'Name of LLC'
    ]);

    const businessName =
      businessNameEntry && hasMeaningfulValue(businessNameEntry.value)
        ? String(businessNameEntry.value).trim()
        : '';

    return this.docSpecFieldConfig.map((config, configIndex) => {
      const matchedAlias = findMatch(config.aliases);

      let value: unknown = matchedAlias ? matchedAlias.value : '';
      let index = matchedAlias ? matchedAlias.index : configIndex;

      const applyRepNameFallback = () => {
        if (parsedRepName && repNameEntry) {
          if (config.label === 'First Name' && parsedRepName.first) {
            value = parsedRepName.first;
            index = repNameEntry.index;
          }
          if (config.label === 'Last Name' && parsedRepName.last) {
            value = parsedRepName.last;
            index = repNameEntry.index;
          }
        }
      };

      if (!matchedAlias) {
        applyRepNameFallback();
      } else if (!hasMeaningfulValue(value)) {
        applyRepNameFallback();
      }

      if (!hasMeaningfulValue(value)) {
        const fallback = this.docSpecFallbackData[config.label];
        if (hasMeaningfulValue(fallback)) {
          value = fallback;
          index = configIndex;
        }
      }

      if (config.label === 'What is the Name of your LLC?') {
        if (businessName) {
          value = businessName;
          index = businessNameEntry?.index ?? configIndex;
        }
      }

      if (config.label === 'Personal or Business Account') {
        value = businessName ? 'Business' : 'Personal';
        index = businessNameEntry?.index ?? configIndex;
      }

      return {
        field: config.label,
        value,
        index
      };
    });
  }

  formatDocSpecValue(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }

    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return '';
      }
    }

    return String(value);
  }

  getDocSpecDisplayValue(entry: DocSpecEntry): string {
    return this.formatDocSpecValue(entry.value);
  }

  isBooleanValue(value: unknown): value is boolean {
    return typeof value === 'boolean';
  }

  isLikelyUrl(value: unknown): boolean {
    if (typeof value !== 'string') {
      return false;
    }
    try {
      const trimmed = value.trim();
      return /^https?:\/\//i.test(trimmed) && !!new URL(trimmed);
    } catch {
      return false;
    }
  }

  async copyDocSpecValue(value: unknown) {
    const normalized = this.formatDocSpecValue(value);

    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(normalized);
        this.message.success('Copied to clipboard');
        return;
      } catch (error) {
        console.error('Failed to copy via navigator clipboard', error);
      }
    }

    if (typeof document !== 'undefined') {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = normalized;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.message.success('Copied to clipboard');
        return;
      } catch (error) {
        console.error('Failed to copy using fallback textarea method', error);
      }
    }

    this.message.warning('Unable to copy value. Please copy it manually.');
  }

  async copyAllDocSpecs() {
    if (!this.docSpecs.length) {
      this.message.warning('Nothing to copy');
      return;
    }

    await this.copyDocSpecValue(this.docSpecCombined);
  }

  trackDocSpecBy(_index: number, item: DocSpecEntry): string {
    return `${item.field}-${item.index}`;
  }

  private updateDocSpecFallbacks(userData: any) {
    if (!userData) {
      this.docSpecFallbackData = {};
      return;
    }

    this.docSpecFallbackData = {
      'First Name': userData.first_name ?? '',
      'Last Name': userData.last_name ?? '',
      'Phone Number': userData.phone ?? '',
      'Email': userData.email ?? ''
    };
  }

  private normalizeDateForInput(value: any): string {
    if (!value) return '';

    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }
  
    return date.toISOString().slice(0, 10);
  }

  backgroundsTab() {
    this.bgLoader = true;
    this.data.getData(`backgrounds/bg-by-user/${this.userForm?.value?.id}`)
      .subscribe({
        next: (res: any) => {
          this.bgLoader = false;
          this.usersBackgrounds = res;
        }
      })
  }

  addBackground() {
    this.backgroundModal = true;
  }

  handleOk() {

    if (this.backgroundForm.get('id')?.value) {
      let obj = {
        ...this.backgroundForm?.value,
        user_id: this.userForm?.value?.id
      };
      this.data.postData(obj, 'backgrounds/update')
        .subscribe({
          next: (res: any) => {
            if (res?.result == 'success') {
              this.backgroundModal = false;
              this.backgroundForm.reset();
              this.message.success('Background updated!');
              this.backgroundsTab();
            } else {
              this.message.error('Failed to update background!');
            }
          }
        })


    } else {

      const obj = {
        provider_id: this.backgroundForm.value?.providerId,
        background_id: this.backgroundForm.value?.backgroundId,
        user_id: this.userForm?.value?.id,
        company_id: this.backgroundForm?.value?.companyId,
        distributor_id: this.backgroundForm?.value?.distributorId,
      }

      this.data.postData(obj, 'backgrounds/create')
        .subscribe({
          next: (res: any) => {
            if (res?.result == 'success') {
              this.message.success('Background created!');
              this.backgroundModal = false;
              this.backgroundForm.reset();
              this.backgroundsTab();
            } else {
              this.message.error('Failed to create background!');
            }
          }
        })
    }
  }

  handleCancel() {
    this.backgroundForm.reset();
    this.backgroundModal = false;
  }

  editBackgroundCheck(bg: any) {
    this.backgroundForm.patchValue({
      'id': bg?.id,
      'backgroundId': bg?.background_id,
      'status': bg?.status,
      'failedDate': bg?.failed_at,
      'completedDate': bg?.completed_at,
      'providerId': bg?.provider_id,
      'companyId': bg?.company_id,
      'distributorId': bg?.distributor_id
    })

    this.backgroundModal = true;
  }

  sort() {
    // console.log(this.providers)
    return this.providers.sort((a: any, b: any) => {
      return a.name.localeCompare(b.name);
    });
  }

  openRequestProviderModal() {
    const companyId = this.userForm.get('company_id')?.value;
    const userProviders = this.userForm.get('providers')?.value || [];

    if (!companyId) {
      this.message.warning('Please select a company first');
      return;
    }

    this.data.getData(`company/associated-company-info/${companyId}/${false}`)
      .subscribe({
        next: (res: any) => {
          if (res?.result == 'success') {
            const companyProviders = res?.data.providers || [];
            const userProviderIds = Array.isArray(userProviders) ? userProviders : [];

            this.availableProviders = companyProviders.filter((p: any) =>
              !userProviderIds.includes(p.id)
            );

            if (this.availableProviders.length === 0) {
              this.message.info('No additional providers available to request');
              return;
            }

            this.requestProviderForm.reset();
            this.requestProviderModal = true;
          }
        },
        error: (err: any) => {
          this.message.error('Failed to load available providers');
        }
      });
  }

  closeRequestProviderModal() {
    this.requestProviderModal = false;
    this.requestProviderForm.reset();
  }

  submitProviderRequest() {
    if (this.requestProviderForm.invalid) {
      return;
    }

    if (!this.isViewingOwnProfile) {
      this.message.error('You can only request providers for your own account');
      return;
    }

    const providerIds = this.requestProviderForm.get('provider_ids')?.value;
    const companyId = this.userForm.get('company_id')?.value;

    if (!providerIds || !Array.isArray(providerIds) || providerIds.length === 0 || !this.currentUser?.id || !companyId) {
      this.message.error('Missing required information');
      return;
    }

    this.data.postData({
      user_id: this.currentUser.id,
      company_id: companyId,
      provider_ids: providerIds
    }, 'users/request-provider')
      .subscribe({
        next: (res: any) => {
          if (res?.result == 'success') {
            this.message.success('Provider request submitted successfully');
            this.closeRequestProviderModal();
          } else {
            this.message.error(res?.message || 'Failed to submit provider request');
          }
        },
        error: (err: any) => {
          this.message.error('Failed to submit provider request');
        }
      });
  }

  payHierarchyTab() {
    if (!this.distributors.length && this.currentUser?.super_admin) {
      this.loadDistributors();
    }
    this.startNewHierarchy();
    this.loadPayHierarchies();
  }

  loadPayHierarchies() {
    if (!this.targetUserId) return;
    this.payHierarchyLoading = true;
    this.data.getData(`pay-hierarchy/user/${this.targetUserId}`, {
      params: { ownersOnly: 'true' }
    })
      .subscribe({
        next: (res: any) => {
          this.payHierarchyList = res?.data || [];
          this.canSeePayHierarchy = this.computeCanSeeHierarchy();
          this.payHierarchyLoading = false;
        },
        error: () => {
          this.payHierarchyLoading = false;
          this.canSeePayHierarchy = this.computeCanSeeHierarchy();
        }
      });
  }

  startNewHierarchy() {
    this.editingHierarchyId = null;
    this.payHierarchyForm.reset({
      provider_id: null,
      company_id: this.userForm.get('company_id')?.value || null,
      // distributor_id: this.userForm.get('distributor_id')?.value || null,
      associated_users: []
    });
    this.payHierarchyUsers = [];
    this.payHierarchyEligibleUsers = [];
  }

  editHierarchy(item: any) {
    if (item?.user_id !== this.targetUserId) {
      return;
    }
    this.editingHierarchyId = item.id;
    this.editHierarchyForm.patchValue({
      provider_id: item.provider_id,
      company_id: item.company_id,
      // distributor_id: item.distributor_id,
      associated_users: Array.isArray(item.associated_users) ? item.associated_users.map((u: any) => u.user_id) : []
    });
    this.payHierarchyUsers = Array.isArray(item.associated_users) ? item.associated_users : [];
    this.onHierarchyProviderChange(item.provider_id);
    this.editHierarchyModal = true;
  }

  onHierarchyProviderChange(providerId: string) {
    if (!providerId) {
      this.payHierarchyEligibleUsers = [];
      return;
    }
    this.payHierarchyEligibleUsers = this.companyUsersForHierarchy.filter((u: any) => {
      if (u?.id === this.targetUserId) return false;
      const provs = Array.isArray((u as any).providers) ? (u as any).providers : [];
      return provs.includes(providerId);
    });
  }

  saveHierarchy() {
    if (!this.targetUserId || this.payHierarchyForm.invalid) {
      this.message.error('Missing required info');
      return;
    }
    const selectedIds = Array.isArray(this.payHierarchyForm.value.associated_users) ? this.payHierarchyForm.value.associated_users : [];
    this.payHierarchyUsers = selectedIds
      .filter((id: any) => id !== this.targetUserId)
      .map((id: any) => ({ user_id: id, added_at: new Date().toISOString() }));
    this.payHierarchyLoading = true;
    const payload: any = {
      user_id: this.targetUserId,
      provider_id: this.payHierarchyForm.value.provider_id,
      company_id: this.payHierarchyForm.value.company_id,
      // distributor_id: this.payHierarchyForm.value.distributor_id,
      associated_users: this.payHierarchyUsers
    };
    const req = this.editingHierarchyId
      ? this.data.postDataNoBodyDotBody(payload, `pay-hierarchy/update/${this.editingHierarchyId}`)
      : this.data.postDataNoBodyDotBody(payload, `pay-hierarchy/create`);

    req.subscribe({
      next: (res: any) => {
        if (res?.result === 'success') {
          this.message.success('Saved pay hierarchy');
          this.startNewHierarchy();
          this.loadPayHierarchies();
        } else {
          this.message.error(res?.message || 'Failed to save');
        }
        this.payHierarchyLoading = false;
      },
      error: () => {
        this.payHierarchyLoading = false;
        this.message.error('Failed to save');
      }
    });
  }

  saveEditHierarchy() {
    if (!this.targetUserId || !this.editingHierarchyId || this.editHierarchyForm.invalid) {
      this.message.error('Missing required info');
      return;
    }
    const selectedIds = Array.isArray(this.editHierarchyForm.value.associated_users) ? this.editHierarchyForm.value.associated_users : [];
    const users = selectedIds
      .filter((id: any) => id !== this.targetUserId)
      .map((id: any) => ({ user_id: id, added_at: new Date().toISOString() }));
    this.payHierarchyLoading = true;
    const payload: any = {
      user_id: this.targetUserId,
      provider_id: this.editHierarchyForm.value.provider_id,
      company_id: this.editHierarchyForm.value.company_id,
      associated_users: users
    };
    this.data.postDataNoBodyDotBody(payload, `pay-hierarchy/update/${this.editingHierarchyId}`)
      .subscribe({
        next: (res: any) => {
          if (res?.result === 'success') {
            this.message.success('Updated pay hierarchy');
            this.editHierarchyModal = false;
            this.startNewHierarchy();
            this.loadPayHierarchies();
          } else {
            this.message.error(res?.message || 'Failed to update');
          }
          this.payHierarchyLoading = false;
        },
        error: () => {
          this.payHierarchyLoading = false;
          this.message.error('Failed to update');
        }
      });
  }

  closeEditHierarchy() {
    this.editHierarchyModal = false;
  }

  viewHierarchy(item: any) {
    const assoc = Array.isArray(item?.associated_users) ? item.associated_users : [];
    this.viewHierarchyOwner = this.getUserName(item?.user_id) || item?.user_name || item?.user_id || '';
    this.viewHierarchyUsers = assoc.map((u: any) => ({
      ...u,
      name: this.getUserName(u?.user_id || u?.id) || (u?.user_id || u?.id)
    }));
    this.viewHierarchyModal = true;
  }

  closeViewHierarchy() {
    this.viewHierarchyModal = false;
    this.viewHierarchyUsers = [];
  }

  deleteHierarchy(id: string) {
    const match = this.payHierarchyList.find((h: any) => h.id === id);
    if (!id || (match && match.user_id !== this.targetUserId)) return;
    this.payHierarchyLoading = true;
    this.data.deleteData(`pay-hierarchy/${id}`).subscribe({
      next: (res: any) => {
        if (res?.result === 'success') {
          this.message.success('Removed pay hierarchy');
          if (this.editingHierarchyId === id) {
            this.startNewHierarchy();
          }
          this.loadPayHierarchies();
        } else {
          this.message.error(res?.message || 'Failed to delete');
        }
        this.payHierarchyLoading = false;
      },
      error: () => {
        this.payHierarchyLoading = false;
        this.message.error('Failed to delete');
      }
    });
  }

  loadDistributors() {
    this.data.getData('distributors').subscribe({
      next: (res: any) => {
        this.distributors = Array.isArray(res?.data) ? res.data : [];
      },
      error: () => { }
    });
  }

  getDistributorName(id: string) {
    if (!id) return '';
    const found = this.distributors.find((d: any) => d.id === id);
    return found ? found.name : '';
  }

  getProviderName(id: string) {
    if (!id) return '';
    const found = this.providers.find((p: any) => p.id === id);
    return found ? found.name : '';
  }

  getCompanyName(id: string) {
    if (!id) return '';
    const found = this.companies.find((c: any) => c.id === id);
    return found ? found.name : '';
  }

  getUserName(id: string) {
    if (!id) return '';
    const fromCompany = this.companyUsersForHierarchy.find((u: any) => u.id === id);
    if (fromCompany) return `${fromCompany.first_name} ${fromCompany.last_name}`.trim();
    const fromHierarchy = this.payHierarchyList.find((h: any) => h.user_id === id);
    if (fromHierarchy && fromHierarchy.user_name) return fromHierarchy.user_name;
    return '';
  }

  private computeCanSeeHierarchy(): boolean {
    if (this.currentUser?.super_admin) return true;
    const currentId = this.currentUser?.id;
    if (!currentId) return false;
    const owns = this.payHierarchyList.some((h: any) => h?.user_id === currentId);
    const associated = this.payHierarchyList.some((h: any) =>
      Array.isArray(h?.associated_users) && h.associated_users.some((u: any) => u?.user_id === currentId)
    );
    return owns || associated || this.isViewingOwnProfile;
  }

  getUserPlans() {
    this.userPlanLoading = true;
    this.data.getData(`provider-payplans/user-plans/${this.userForm.get('id')?.value}`)
      .subscribe({
        next: (res: any) => {
          this.userPlans = res;
          this.userPlanLoading = false;
        }
      })
  }

  providerPlans() {
    this.userPlanLoading = true
    const providers = encodeURIComponent(JSON.stringify(this.userForm.get('providers')?.value));
    this.data.getData(`provider-payplans/plans-for-user?providers=${providers}&company=${this.userForm.get('company_id')?.value}`)
      .subscribe({
        next: (res: any) => {
          this.userPlanLoading = false;
          this.availableProviderPlans = res;
          this.planProviderModal = true;
          this.planProviderForm.reset();
        }
      })

  }

  saveProviderPlans() {
    this.userPlanLoading = true;
    let obj = {
      user_id: this.userForm.get('id')?.value,
      provider_id: this.planProviderForm.get('plan_id')?.value?.provider_id,
      plan_id: this.planProviderForm.get('plan_id')?.value?.id,
    }

    this.data.postData(obj, `provider-payplans/save-plan`)
      .subscribe({
        next: (res: any) => {
          this.userPlans = res;
          this.userPlanLoading = false;
          this.closePlanModal()
        }
      })

  }

  updatePlanStatus(p: any) {
    this.userPlanLoading = true;
    let obj = {
      id: p.id,
      status: p.status,
      user_id: this.userForm.get('id')?.value
    }

    this.data.postData(obj, `provider-payplans/assignment-status`)
      .subscribe({
        next: (res: any) => {
          this.userPlanLoading = false;
          this.userPlans = res;
        }
      })
  }

  closePlanModal() {
    this.planProviderModal = false;
    this.planProviderForm.reset();
  }

  addDocument() {
    this.documentModal = true;
  }

  handleDocumentCancel() {
    this.documentModal = false;
    this.documentForm.reset();
    this.availableDocuments = [];
  }

  handleDocumentOk() {
    if(this.documentForm.valid) {
      this.documentLoading = true;
      let documentBody = {
        company_id: this.documentForm.get('company_id')?.value,
        documents: this.documentForm.get('document_id')?.value,
        user_id: this.userForm.get('id')?.value,
        email: this.userForm.get('email')?.value,
        first_name: this.userForm.get('first_name')?.value,
        last_name: this.userForm.get('last_name')?.value
      } 

      this.data.postData(documentBody, 'users/add-doc')
        .subscribe({
          next: (res: any) => {
            if(res?.result == 'success') {
              if(res?.data?.failedDocs?.length > 0) {
                const failedNames = res?.data?.failedDocs?.map((doc: any) => {return doc.name})
                this.message.warning(`The following docs are already assigned: ${failedNames}`);
              }
              if(res?.data?.successfulDocs?.length > 0) {
                this.getPortalDocs();
                const successDocs = res?.data?.successfulDocs?.map((doc: any) => {return doc.name})
                this.message.success(`The following docs have been assigned: ${successDocs}`);
                this.handleDocumentCancel();
              }
            }else {
              this.message.error('Failed to save docs')
            }
              this.documentLoading = false;
          },
          error: (err: any) => {
            this.documentLoading = false;
            console.log('err: ', err)
          }
        })
    }else {
      alert('Please fill in all required fields')
    }
  }

  getAvailableCompanyDocs() {
    if(this.documentForm.get('company_id')?.value) {
      this.data.getData(`company/company-docs/${this.documentForm.get('company_id')?.value}`)
        .subscribe({
          next: (response: any) => {
            if(response?.result == 'success') {
              this.availableDocuments = response?.data;
            }
          },
          error: (err: any) => {
            console.log('err: ', err)
          }
        })
    }
  }

  getUserLogs() {
    this.data.getData(`users/user-logs/${this.userForm.get('id')?.value}`)
      .subscribe({
        next: (res: any) => {
          this.userLogs = res;
        }
      })
  }

  addNote() {
    let obj = {
      text: this.noteForm.get('note')?.value,
      type: 'note',
      user_id: this.userForm.get('id')?.value
    }

    this.data.postData(obj, `users/add-log`)
      .subscribe({
        next: (res: any) => {
          this.userLogs?.unshift({
            by: this.currentUser?.first_name + ' ' + this.currentUser?.last_name,
            text: this.noteForm.get('note')?.value,
            date: new Date().toISOString(),
            type: 'note'
          })

          this.noteForm.reset();
        }
      })

  }


}
